import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';
var InfoDialog = function InfoDialog(props) {
  var content = props.content,
    onClose = props.onClose,
    className = props.className;
  var dialogClassName = "".concat(className ? className : '', " info-dialog");
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, props, {
    body: content,
    onHide: onClose,
    className: dialogClassName
  }));
};
InfoDialog.propTypes = _objectSpread(_objectSpread({}, baseDialogPropTypes), {}, {
  content: PropTypes.node
});
export default InfoDialog;